// import React from 'react'
// import style from './CuttingMachinesCarbon.module.css'
// import { useTranslation } from 'react-i18next'
// import { Link } from 'react-router-dom'
//
// const CuttingMachines = () => {
//   const { t } = useTranslation()
//   return (
//     <div className={style.engineering} id="engineering">
//       <div className={`${'customContainer'} ${style.engineering_wrap}`}>
//         <h2 className={style.title}>{t('сuttingMachines.title')}</h2>
//         <Link to={'http://prostir3d.com'} className={style.button}>
//           {t('сuttingMachines.button')}
//         </Link>
//       </div>
//     </div>
//   )
// }
//
// export default CuttingMachines

import React, { useState } from 'react'
import style from './CuttingMachinesCarbon.module.css'
import { useTranslation } from 'react-i18next'
import ContactsPopup from '../../../Components/PopUp/ContactPopUp'
import { ScrollArrow } from '../../../Components/ScrollArrow/ScrollArrow'

const CuttingMachines = () => {
  const { t } = useTranslation()
  const [showPopup, setShowPopup] = useState(false)

  const handleOpenPopup = () => setShowPopup(true)
  const handleClosePopup = () => setShowPopup(false)

  const titleText = t('сuttingMachines.title')

  return (
    <div className={style.engineering} id="engineering">
      <div className={`${'customContainer'} ${style.engineering_wrap}`}>
        <h2 className={style.title}>{titleText}</h2>
        <button onClick={handleOpenPopup} className={style.button}>
          {t('сuttingMachines.button')}
        </button>
      </div>
      <ContactsPopup
        show={showPopup}
        onHide={handleClosePopup}
        title={titleText}
      />
      <div className={style.block_arrow}>
        <ScrollArrow />
      </div>
    </div>
  )
}

export default CuttingMachines
